import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { DivisionSummaryDetailReport } from './Pages/listing';

export const DivisionSummaryDetailReportRoutes = ({ match }) => (
    <Fragment>
        <Route exact path = {`${match.path}`} component={DivisionSummaryDetailReport} />
    </Fragment>
)